import { render } from "./CompanyAddNewSalesPerson.vue?vue&type=template&id=15220d10"
import script from "./CompanyAddNewSalesPerson.vue?vue&type=script&lang=js"
export * from "./CompanyAddNewSalesPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__